import React from 'react';
import { AND, COND, OP } from "../../../misc/RuleObjectTypes";

const SubConditionFilter = ({ right, filters }) => {
  if (filters && filters.length > 0)
    return (
      <div className={`filter-block ${right || ""}`}>
        {filters.map((el, index) => {
          if (el.type === COND)
            return (
              <div
                className="tw-text-[#090A42] tw-text-sm"
                key={index}
              >
                {el.attrName} {el.conditionOpName} {el.AttrValueName}
              </div>
            );
          else if (el.type === OP)
            return (
              <div
                className="tw-text-[#747593] tw-text-sm"
                key={index}
              >
                {parseInt(el.value) === AND ? "And" : "Or"}
              </div>
            );
        })}
      </div>
    );
  else return null;
};
export default SubConditionFilter;
